/* Feb-2026 · Reader-preference hook — hide the Mature Audiences Only
 * super-shelf from the main Bookstore carousel.
 *
 * Same pattern as `useReaderTagPreferences`: on-device only, no server
 * round-trip (this is a warning-related preference). Value lives in
 * localStorage under `bs-hide-mature-shelves`. Any surface that mutates
 * it dispatches a synthetic `storage` event so other tabs update live.
 */
import { useCallback, useEffect, useState } from 'react';

export const HIDE_MATURE_KEY = 'bs-hide-mature-shelves';

function read() {
  try { return localStorage.getItem(HIDE_MATURE_KEY) === '1'; }
  catch { return false; }
}

export default function useHideMatureShelves() {
  const [hidden, setHidden] = useState(read);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === HIDE_MATURE_KEY) setHidden(read()); };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const setHiddenPersist = useCallback((next) => {
    try {
      if (next) localStorage.setItem(HIDE_MATURE_KEY, '1');
      else       localStorage.removeItem(HIDE_MATURE_KEY);
      window.dispatchEvent(new StorageEvent('storage', { key: HIDE_MATURE_KEY }));
    } catch { /* private mode */ }
    setHidden(!!next);
  }, []);

  return { hidden, setHidden: setHiddenPersist };
}
